import { getProfileProviderConfig, getPermissions } from '@paintscout/util/builder'
import { BaseAdminProvider, GoogleCalendarProviderForm } from '../Integrations'
import type { OptionsDocument, UserPreferencesDocument } from 'paintscout'
import type { Auth0UserWithClaims } from '../../providers/UserProvider/UserContext'
import UserProvider from '../../providers/UserProvider/UserProvider'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '../../styles'
import { useFormikContext, Form } from 'formik'
import { makeStyles } from '@material-ui/core'
import SettingsPage from '../../components/SettingsPage'
import React from 'react'

const useStyles = makeStyles<Theme, UserAdminIntegrationsFormProps>(
  (_theme) => ({
    root: {
      overflowY: 'auto'
    }
  }),
  { name: 'UserAdminCalendarForm' }
)

export interface UserAdminIntegrationsFormProps {
  classes?: StyleClasses<typeof useStyles>
}

function UserAdminCalendarForm(props: UserAdminIntegrationsFormProps) {
  const classes = useStyles(props)
  const { values } = useFormikContext<{
    user: Auth0UserWithClaims
    preferences: UserPreferencesDocument
    options: OptionsDocument
  }>()

  const { preferences, user, options } = values
  const roles = user?.app_metadata?.roles ?? user?.['https://paintscout.com/app_metadata']?.roles ?? []
  const permissions = getPermissions(options, roles)
  const googleCalProviderConfig = getProfileProviderConfig({ preferences, name: 'google-calendar' })
  const companyId = user?.app_metadata?.companyId
  const userId = user?.user_id

  return (
    <SettingsPage title="Calendar Integrations">
      <UserProvider
        user={{
          ...user,
          app_metadata: {
            ...user?.app_metadata,
            permissions
          }
        }}
        preferences={preferences}
      >
        <Form className={classes.root}>
          <BaseAdminProvider title={'Google Calendar'} providerConfig={googleCalProviderConfig}>
            <GoogleCalendarProviderForm isAdminIntegrations userId={userId} companyId={companyId} />
          </BaseAdminProvider>
        </Form>
      </UserProvider>
    </SettingsPage>
  )
}

export default UserAdminCalendarForm
